import React, { useState } from 'react';
import { Sparkles, Gem, LifeBuoy, MessageSquareMore } from 'lucide-react';

type MenuItem = 'discover' | 'casino' | 'live' | 'chat';

interface MenuItemConfig {
  id: MenuItem;
  label: string;
  icon: React.ReactNode;
}

const BottomMenuBar: React.FC = () => {
  const [activeItem, setActiveItem] = useState<MenuItem>('discover');

  const handleMenuClick = (itemId: MenuItem) => {
    console.log(`Menu item clicked: ${itemId}`);
    setActiveItem(itemId);
  };

  const iconColor = (isActive: boolean) => (isActive ? '#ffd700' : 'rgba(255, 255, 255, 0.7)');
  const iconSize = 24;

  const menuItems: MenuItemConfig[] = [
    {
      id: 'discover',
      label: 'Discover',
      icon: <Sparkles size={iconSize} color={iconColor(activeItem === 'discover')} />,
    },
    {
      id: 'casino',
      label: 'Casino',
      icon: <Gem size={iconSize} color={iconColor(activeItem === 'casino')} />,
    },
    {
      id: 'live',
      label: 'Live',
      icon: <LifeBuoy size={iconSize} color={iconColor(activeItem === 'live')} />,
    },
    {
      id: 'chat',
      label: 'Chat',
      icon: <MessageSquareMore size={iconSize} color={iconColor(activeItem === 'chat')} />,
    },
  ];

  return (
    <>
      <style>{`
        .bottom-menu-bar {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          height: 70px;
          background: rgba(26, 26, 46, 0.95);
          backdrop-filter: blur(10px);
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          display: flex;
          justify-content: space-around;
          align-items: center;
          z-index: 10000;
          padding: 0 20px;
          box-sizing: border-box;
        }
        .menu-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          padding: 8px 16px;
          border-radius: 8px;
          transition: all 0.2s ease;
          flex: 1;
          max-width: 80px;
        }
        .menu-item:hover {
          background: rgba(255, 255, 255, 0.05);
        }
        .menu-item-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 4px;
        }
        .menu-item-label {
          font-size: 11px;
          color: rgba(255, 255, 255, 0.7);
          text-align: center;
          font-weight: 500;
        }
      `}</style>
      <div className="bottom-menu-bar">
        {menuItems.map((item) => (
          <div
            key={item.id}
            className={`menu-item ${activeItem === item.id ? 'active' : ''}`}
            onClick={() => handleMenuClick(item.id)}
          >
            <div className="menu-item-icon">{item.icon}</div>
            <div className="menu-item-label">{item.label}</div>
          </div>
        ))}
      </div>
    </>
  );
};

export default BottomMenuBar;
